export default __webpack_public_path__ + "static/media/commonocean-models.76ff3f41.md";